export const isNetworkError = (error: unknown): boolean => {
  if (!(error instanceof Error)) return false;
  if (error.message === 'Network Error') return true;
  if (
    typeof navigator !== 'undefined' &&
    typeof navigator.onLine === 'boolean' &&
    !navigator.onLine
  ) {
    return true;
  }
  return false;
};